import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ILogInLogState } from 'src/app/core/models/itinerary.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';

@Component({
  selector: 'log-in-log-modal',
  templateUrl: './log-in-log-modal.component.html',
  styleUrls: ['./log-in-log-modal.component.scss']
})
export class LogInLogModalComponent implements OnInit, OnDestroy {
  @Input() isActive: boolean;

  @Output() closeModal = new EventEmitter<boolean>();

  subscriptions = new Subscription();

  logInLogState: ILogInLogState;
  showCloseFooterModal: boolean = false;

  constructor(readonly itineraryService: ItineraryService) {}

  ngOnInit(): void {
    this.callComponentSubscriptions();
  }

  callComponentSubscriptions() {
    this.subscriptions.add(
      this.itineraryService.getLogInLogState().subscribe((state) => {
        this.logInLogState = state;

        if (state?.logInLogRegistered) {
          this.showCloseFooterModal = true;
        }
      })
    );
  }

  saveLogInLog() {
    this.itineraryService.dispatchPostLogInLog();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
